import React, { useEffect, useState, useMemo } from "react";
import { useFormik } from "formik";
import { useOfferFormContext } from "../OfferFormContext";
import PrimaryButton from "../../PrimaryButton";
import GreyButton from "../../GreyButton";
import { locationOfferSchema } from "../../../../utils/validationSchemas";
import SelectOption from "../SelectOption";
import AddNewLocation from "./AddNewLocation";
import { useDispatch, useSelector } from "react-redux";
import { getFranchises, addFranchise } from "../../../../services/franchiseService";
import { createOffer } from "../../../../services/offerService";
import Checkbox from "../../Checkbox";
import { ReactComponent as UncheckedIcon } from "../../../../Assets/Icons/uncheckedBlackBox.svg";
import LocationIcon from "../../../../Assets/Icons/Location.svg";
import RadioSelection from "../../RadioSelection";
import CSVUpload from "../CSVUpload";
import toast from "../../../../utils/toast";
import { uploadFile } from "../../../../utils/s3";
import { Modal, Drawer, Tooltip } from "antd";
import { ReactComponent as TickIcon } from "../../../../Assets/Icons/whiteplaintick.svg";
import { ReactComponent as CSVIcon } from "../../../../Assets/Icons/csvupload.svg";
import { ReactComponent as CloseIconModal } from "../../../../Assets/Icons/popupCloseIcon.svg";
import { ReactComponent as GreyCross } from "../../../../Assets/Icons/greyCross.svg";
import UploadCSVDrawer from "./UploadCSVDrawer";
import "./ViewAllModal.scss";
import { scrollToFirstError } from "../../../../utils/utilFunctions";

const Location = ({
    stepIndex,
    setStepIndex,
    handlePrevious,
    setPayloadData,
    editOfferData,
    isEdit,
    selectedMerchant,
    handleSaveAndExit,
}) => {
    const dispatch = useDispatch();
    const loading = useSelector((state) => state?.franchiseReducer?.loading);
    const offerData = useSelector((state) => state?.offerReducer?.createdOffer);
    const role = useSelector(
        (state) => state?.authReducer?.tokenData?.user?.role
    );
    const { registerNextAction, setIsNextLoading, setIsNextDisabled } = useOfferFormContext();
    console.log(offerData, "offerData1234567890=++");
    const [locations, setLocations] = useState([]);
    console.log(locations, "locations1234567890=++");
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedLocationIds, setSelectedLocationIds] = useState([]);
    const [locationNames, setLocationNames] = useState([]);
    const [addClicked, setAddClicked] = useState(false);
    const [uploadClicked, setUploadClicked] = useState(false);
    const [csvDrawerOpen, setCsvDrawerOpen] = useState(false);
    const [allStores, setAllStores] = useState(false);
    const [fileloading, setFileLoading] = useState(false);
    const [fileUrl, setFileUrl] = useState(null);
    const [fileData, setFileData] = useState();
    const [viewAllVisible, setViewAllVisible] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);

    // Persist selection across steps (and refresh) scoped to current offer id
    const STORAGE_KEY = React.useMemo(
        () => (offerData?._id ? `OFFER_LOCATION_STATE_${offerData._id}` : null),
        [offerData?._id]
    );

    useEffect(() => {
        if (offerData?.availableAcrossAllStores !== undefined) {
            setAllStores(offerData.availableAcrossAllStores);
        }
    }, [offerData]);

    // Rehydrate saved selection once locations are loaded
    useEffect(() => {
        if (!STORAGE_KEY || locations.length === 0) return;
        try {
            const raw = sessionStorage.getItem(STORAGE_KEY);
            if (!raw) return;
            const saved = JSON.parse(raw);
            if (Array.isArray(saved?.selectedLocationIds)) {
                setSelectedLocationIds(saved.selectedLocationIds);
                // Map ids back to location objects and names
                const savedObjects = saved.selectedLocationIds
                    .map((id) => locations.find((l) => l?._id === id))
                    .filter(Boolean);
                setSelectedLocations(savedObjects);
                setLocationNames(savedObjects.map((l) => l?.name));
            }
            if (typeof saved?.allStores === 'boolean') {
                setAllStores(saved.allStores);
            }
        } catch (_) { }
    }, [STORAGE_KEY, locations.length]);

    const validateFile = (data) => {
        var idxDot = data.lastIndexOf(".") + 1;
        var extFile = data.substr(idxDot, data.length).toLowerCase();
        if (extFile == "csv" || extFile == "xlsx" || extFile == "xls") {
            return true;
        } else {
            return false;
        }
    };
    const handleAcceptedFiles = async (event) => {
        const file = event.target.files[0];
        console.log("file", file);
        if (validateFile(file?.name)) {
            setFileLoading(true);
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e.target.result;
                const lines = text.split("\n");

                // Split a CSV line by commas while respecting quoted fields
                const splitCsvLine = (line) => {
                    const matches = line
                        .trim()
                        .match(/("[^"]*"|[^,]+)(?=,|$)/g);
                    if (!matches) return [];
                    return matches.map((m) => m.replace(/^"|"$/g, "").trim());
                };

                const headers = (splitCsvLine(lines[0]) || [])
                    .map((h) => h.trim().toLowerCase());
                const locationData = lines
                    .slice(1) // Skip header row
                    .filter((line) => line.trim() !== "") // Remove empty lines
                    .map((line) => {
                        const columns = splitCsvLine(line);
                        // Create working hours object
                        const workingHours = {
                            monday: {
                                open: columns[headers.indexOf("monday_open")] || "",
                                close: columns[headers.indexOf("monday_close")] || "",
                            },
                            tuesday: {
                                open: columns[headers.indexOf("tuesday_open")] || "",
                                close: columns[headers.indexOf("tuesday_close")] || "",
                            },
                            wednesday: {
                                open: columns[headers.indexOf("wednesday_open")] || "",
                                close: columns[headers.indexOf("wednesday_close")] || "",
                            },
                            thursday: {
                                open: columns[headers.indexOf("thursday_open")] || "",
                                close: columns[headers.indexOf("thursday_close")] || "",
                            },
                            friday: {
                                open: columns[headers.indexOf("friday_open")] || "",
                                close: columns[headers.indexOf("friday_close")] || "",
                            },
                            saturday: {
                                open: columns[headers.indexOf("saturday_open")] || "",
                                close: columns[headers.indexOf("saturday_close")] || "",
                            },
                            sunday: {
                                open: columns[headers.indexOf("sunday_open")] || "",
                                close: columns[headers.indexOf("sunday_close")] || "",
                            },
                        };

                        return {
                            name: columns[headers.indexOf("name")] || "",
                            email: columns[headers.indexOf("email")] || "",
                            address: columns[headers.indexOf("address")] || "",
                            phone: columns[headers.indexOf("phone")] || "",
                            // Generate a temporary ID for new locations
                            _id: `temp_${Date.now()}_${Math.random()
                                .toString(36)
                                .substr(2, 9)}`,
                            googlePlaceId: {
                                address: columns[headers.indexOf("address")] || "",
                            },
                            workingHours: workingHours,
                        };
                    })
                    .filter((location) => location.name && location.address); // Only include locations with name and address

                if (locationData.length > 0) {
                    // Add parsed locations to the beginning of the list (newest first)
                    setLocations((prevLocations) => [...locationData, ...prevLocations]);

                    // Add parsed locations to selected locations at the beginning
                    const newLocationIds = locationData.map((loc) => loc._id);
                    const newLocationNames = locationData.map((loc) => loc.name);

                    setSelectedLocations((prev) => [...locationData, ...prev]);
                    setSelectedLocationIds((prev) => [...newLocationIds, ...prev]);
                    setLocationNames((prev) => [...newLocationNames, ...prev]);

                    setFieldValue("document", file?.name);
                    toast.success(
                        `${locationData.length} location(s) added successfully from CSV`
                    );
                } else {
                    toast.error(
                        "No valid locations found in the CSV file. Please ensure the file has the required columns."
                    );
                    handleRejectedFiles(file, true);
                }
                setFileLoading(false);
            };

            reader.onerror = () => {
                toast.error("Error reading the CSV file");
                handleRejectedFiles(file, true);
                setFileLoading(false);
            };

            reader.readAsText(file);
        } else {
            toast.error(`Only .csv, .xls, and .xlsx files are allowed!`);
            handleRejectedFiles(file, true);
        }
    };

    const handleRejectedFiles = (filesOrFile, silent = false) => {
        const file = Array.isArray(filesOrFile)
            ? filesOrFile[0]
            : filesOrFile;
        setFileData(null);
        setFieldValue("document", null);
        if (silent) return;
        if (file?.errors) {
            file?.errors?.forEach((error) => {
                toast.error(error.message);
            });
        } else {
            toast.error("Invalid file format. Please upload a valid CSV file.");
        }
    };

    const handleClear = () => {
        setFileUrl(null);
        setFileData(null);
        setFieldValue("document", "");
        // Remove temporary locations that were added via CSV
        const tempLocations = selectedLocations.filter((loc) =>
            loc._id.startsWith("temp_")
        );
        const tempLocationNames = tempLocations.map((loc) => loc.name);

        setSelectedLocations((prev) =>
            prev.filter((loc) => !loc._id.startsWith("temp_"))
        );
        setSelectedLocationIds((prev) =>
            prev.filter((id) => !id.startsWith("temp_"))
        );
        setLocationNames((prev) =>
            prev.filter((name) => !tempLocationNames.includes(name))
        );
        setLocations((prev) => prev.filter((loc) => !loc._id.startsWith("temp_")));
    };

    const fillUpForm = (data) => {
        if (data?.tempLocations) {
            const locObjects = [];
            const locIds = [];
            const locNames = [];

            data.tempLocations?.map((location) => {
                locObjects?.push(location);
                locIds?.push(location?._id);
                locNames?.push(location?.name);
            });

            setSelectedLocations(locObjects);
            setSelectedLocationIds(locIds);
            setLocationNames(locNames);
        }
    };

    useEffect(() => {
        if (editOfferData !== null && isEdit == true) {
            fillUpForm(editOfferData);
        } else {
            fillUpForm(offerData);
        }
    }, [offerData, editOfferData]);

    const getAllFranchises = async () => {
        const franchisePromise = await dispatch(role == "admin" ? getFranchises({ merchant: selectedMerchant?._id }) : getFranchises()).unwrap();
        if (franchisePromise?.success === true) {
            setLocations(franchisePromise?.data);
        }
    };

    useEffect(() => {
        getAllFranchises();
    }, []);

    const initialValues = {
        location: [],
        locationAdded: "Add a new location",
        document: "",
    };

    const payload = {
        locations: allStores ? [] : selectedLocationIds,
        availableAcrossAllStores: allStores,
        offerId: offerData?._id,
        merchantId: selectedMerchant?._id,
        offerType: offerData?.offerType,
        isCreated: false,
    };

    useEffect(() => {
        setPayloadData(payload);
    }, [selectedLocationIds, offerData?._id, allStores]);

    // Persist whenever selection changes
    useEffect(() => {
        if (!STORAGE_KEY) return;
        try {
            sessionStorage.setItem(
                STORAGE_KEY,
                JSON.stringify({ selectedLocationIds, allStores })
            );
        } catch (_) { }
    }, [STORAGE_KEY, selectedLocationIds, allStores]);

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: locationOfferSchema(allStores),
        enableReinitialize: true,

        onSubmit: async (values) => {
            try {
                // 1) If any selected locations are temporary (from CSV), resolve them to real stores first
                const tempSelected = selectedLocations.filter((l) => String(l?._id || "").startsWith("temp_"));
                if (tempSelected.length > 0) {
                    try {
                        // Pre-match temps to any existing stores to avoid duplicate creation
                        const existingList = Array.isArray(locations) ? locations : [];
                        const preMatched = tempSelected.map((t) => {
                            return existingList.find((x) => {
                                const xAddr = x?.googlePlaceId?.address || x?.address || "";
                                const tAddr = t?.googlePlaceId?.address || t?.address || "";
                                const samePhone = (String(x?.phone || "").replace(/\D/g, "") || "") === (String(t?.phone || "").replace(/\D/g, "") || "");
                                return (String(x?.name || "").trim() === String(t?.name || "").trim() && String(xAddr).trim() === String(tAddr).trim()) || samePhone;
                            }) || null;
                        }).filter(Boolean);

                        const toCreate = tempSelected.filter((t) => !preMatched.find((m) => (m?.name || "").trim() === (t?.name || "").trim() && (m?.googlePlaceId?.address || m?.address || "").trim() === (t?.googlePlaceId?.address || t?.address || "").trim()));

                        if (toCreate.length > 0) {
                            const bulkPayload = {
                                locations: toCreate.map((l) => ({
                                    name: l?.name,
                                    email: l?.email || "",
                                    phone: l?.phone || "",
                                    googlePlaceId: l?.googlePlaceId || { address: l?.address || "" },
                                    tradingHours: l?.workingHours || l?.tradingHours || undefined,
                                })),
                            };
                            await dispatch(addFranchise(bulkPayload)).unwrap();
                        }

                        // Refresh full list to resolve real IDs (covers both created and pre-existing)
                        const refreshed = await dispatch(role == "admin" ? getFranchises({ merchant: selectedMerchant?._id }) : getFranchises()).unwrap();
                        const refreshedList = refreshed?.data || [];

                        // Build new selected arrays: keep existing real ones + map temps to created/existing by name/address/phone
                        const isTemp = (id) => String(id || "").startsWith("temp_");
                        const persistentIds = selectedLocationIds.filter((id) => !isTemp(id));
                        const persistentObjs = selectedLocations.filter((l) => !isTemp(l?._id));

                        const resolved = tempSelected.map((t) => {
                            const match = refreshedList.find((x) => {
                                const xAddr = x?.googlePlaceId?.address || x?.address || "";
                                const tAddr = t?.googlePlaceId?.address || t?.address || "";
                                const samePhone = (String(x?.phone || "").replace(/\D/g, "") || "") === (String(t?.phone || "").replace(/\D/g, "") || "");
                                return (String(x?.name || "").trim() === String(t?.name || "").trim() && String(xAddr).trim() === String(tAddr).trim()) || samePhone;
                            });
                            return match || null;
                        }).filter(Boolean);

                        const newIds = resolved.map((n) => n?._id).filter(Boolean);
                        const newObjs = resolved;
                        const finalIds = [...new Set([...persistentIds, ...newIds])];
                        const finalObjs = [...persistentObjs, ...newObjs];
                        setSelectedLocationIds(finalIds);
                        setSelectedLocations(finalObjs);
                        setLocationNames(finalObjs.map((l) => l?.name));
                    } catch (_) {
                        // If persisting fails, retry by just mapping to existing list without clearing selection
                        try {
                            const refreshed = await dispatch(role == "admin" ? getFranchises({ merchant: selectedMerchant?._id }) : getFranchises()).unwrap();
                            const refreshedList = refreshed?.data || [];
                            const isTemp = (id) => String(id || "").startsWith("temp_");
                            const persistentIds = selectedLocationIds.filter((id) => !isTemp(id));
                            const persistentObjs = selectedLocations.filter((l) => !isTemp(l?._id));
                            const resolved = tempSelected.map((t) => {
                                const match = refreshedList.find((x) => {
                                    const xAddr = x?.googlePlaceId?.address || x?.address || "";
                                    const tAddr = t?.googlePlaceId?.address || t?.address || "";
                                    const samePhone = (String(x?.phone || "").replace(/\D/g, "") || "") === (String(t?.phone || "").replace(/\D/g, "") || "");
                                    return (String(x?.name || "").trim() === String(t?.name || "").trim() && String(xAddr).trim() === String(tAddr).trim()) || samePhone;
                                });
                                return match || null;
                            }).filter(Boolean);
                            const finalIds = [...new Set([...persistentIds, ...resolved.map((r) => r?._id).filter(Boolean)])];
                            const finalObjs = [...persistentObjs, ...resolved];
                            setSelectedLocationIds(finalIds);
                            setSelectedLocations(finalObjs);
                            setLocationNames(finalObjs.map((l) => l?.name));
                        } catch (_) { }
                    }
                }

                const createPromise = await dispatch(
                    createOffer({
                        locations: allStores ? [] : selectedLocationIds.filter((id) => !String(id || "").startsWith("temp_")),
                        availableAcrossAllStores: allStores,
                        offerId: offerData._id,
                        merchantId: selectedMerchant?._id,
                        offerType: offerData.offerType,
                    })
                )?.unwrap();

                if (createPromise?.success === true) {
                    const stepIndex = role === "admin" ? 8 : 7;
                    setStepIndex(stepIndex); // Always go to step 7 (Review) after Location
                }
            } catch (error) {
                console.error("API Error:", error);
            }
        },
    });

    const { location, locationAdded, document } = formik.values;

    const {
        handleChange,
        handleBlur,
        errors,
        touched,
        setFieldValue,
        handleSubmit,
        setValues,
    } = formik;

    const attemptNext = async () => {
        formik.setTouched({ location: true });
        const validationErrors = await formik.validateForm();
        if (Object.keys(validationErrors || {}).length > 0) {
            scrollToFirstError(validationErrors, ["location"]);
            return;
        }
        formik.handleSubmit();
    };

    // Register the Next action for the Layout's Next button
    useEffect(() => {
        registerNextAction(() => attemptNext());
    }, [registerNextAction, formik.values, selectedLocationIds, allStores, locations]);

    // Sync loading state with Layout's Next button
    useEffect(() => {
        setIsNextLoading(loading);
    }, [loading, setIsNextLoading]);

    // Update disabled state for Next button
    useEffect(() => {
        setIsNextDisabled(!allStores && selectedLocationIds.length === 0);
    }, [allStores, selectedLocationIds, setIsNextDisabled]);

    const handleClick = (id, name, location) => {
        const isSelected = selectedLocations?.find((loc) => loc?._id === id);

        if (isSelected) {
            const updatedLocations = selectedLocations?.filter(
                (loc) => loc?._id !== id
            );
            setSelectedLocations(updatedLocations);

            const updatedIds = selectedLocationIds?.filter((locId) => locId !== id);
            setSelectedLocationIds(updatedIds);

            const updatedNames = locationNames?.filter((t) => t !== name);
            setLocationNames(updatedNames);
        } else {
            const loc = locations?.find((l) => l?._id === id);
            setSelectedLocations((prev) => [...prev, loc]);
            setSelectedLocationIds((prev) => [...prev, loc?._id]);
            setLocationNames((prev) => [...prev, loc?.name]);
        }
    };

    const isLocationClicked = (id) => {
        return selectedLocationIds?.includes(id);
    };

    const handleAddClick = () => {
        setAddClicked(true);
        setUploadClicked(false);
    };

    const handleUploadClick = () => {
        if (addClicked == true) {
            setUploadClicked(true);
        }
    };

    useEffect(() => {
        setFieldValue("location", locationNames);
    }, [locationNames]);

    // Clear validation errors when allStores becomes true
    useEffect(() => {
        if (allStores && formik.errors.location) {
            formik.setFieldError("location", undefined);
        }
    }, [allStores]);

    // Disable "Available Across All Stores" when no locations exist
    useEffect(() => {
        if (locations?.length === 0 && allStores) {
            setAllStores(false);
        }
    }, [locations?.length, allStores]);

    const handleSaveExit = async () => {
        if (typeof handleSaveAndExit === 'function') {
            await handleSaveAndExit();
        } else {
            console.warn('handleSaveAndExit not provided to Location component');
        }
    };

    const handleLocationToggle = (id, name, location) => {
        const isSelected = selectedLocationIds?.includes(id);

        if (isSelected) {
            setSelectedLocations(prev => prev.filter(loc => loc?._id !== id));
            setSelectedLocationIds(prev => prev.filter(locId => locId !== id));
            setLocationNames(prev => prev.filter(t => t !== name));
        } else {
            const loc = locations?.find(l => l?._id === id);
            if (loc) {
                setSelectedLocations(prev => [...prev, loc]);
                setSelectedLocationIds(prev => [...prev, loc?._id]);
                setLocationNames(prev => [...prev, loc?.name]);
            }
        }
    };

    const handleAllStoresToggle = () => {
        if (locations?.length > 0) {
            const nextAllStores = !allStores;
            setAllStores(nextAllStores);
            if (nextAllStores) {
                setSelectedLocationIds(locations.map(l => l._id));
                setSelectedLocations(locations);
                setLocationNames(locations.map(l => l.name));
            } else {
                setSelectedLocationIds([]);
                setSelectedLocations([]);
                setLocationNames([]);
            }
        }
    };

    useEffect(() => {
        setFieldValue("location", locationNames);
    }, [locationNames]);

    const isNextButtonBusy = Boolean(loading);
    const isNextButtonDisabled = isNextButtonBusy ||
        (!allStores && (selectedLocationIds.length === 0 || !formik.values.location || (Array.isArray(formik.values.location) && formik.values.location.length === 0)));

    const nextButtonLabel = isNextButtonBusy ? (
        <span className="flex items-center justify-center gap-2">
            <span className="offer-btn-spinner" />
            <span>Processing...</span>
        </span>
    ) : (
        "Next"
    );

    const handleBatchLocationSelection = (locs, isSelected) => {
        if (isSelected) {
            // Add all that are not already selected
            const newLocs = locs.filter(l => !selectedLocationIds.includes(l._id));
            if (newLocs.length > 0) {
                setSelectedLocations(prev => [...prev, ...newLocs]);
                setSelectedLocationIds(prev => [...prev, ...newLocs.map(l => l._id)]);
                setLocationNames(prev => [...prev, ...newLocs.map(l => l.name)]);
            }
        } else {
            // Remove all
            const idsToRemove = locs.map(l => l._id);
            setSelectedLocations(prev => prev.filter(l => !idsToRemove.includes(l._id)));
            setSelectedLocationIds(prev => prev.filter(id => !idsToRemove.includes(id)));
            const namesToRemove = locs.map(l => l.name);
            setLocationNames(prev => prev.filter(n => !namesToRemove.includes(n)));
        }
    };

    const displayedLocations = useMemo(() => {
        const selected = locations.filter(loc => selectedLocationIds.includes(loc._id));
        const unselected = locations.filter(loc => !selectedLocationIds.includes(loc._id));
        return [...selected, ...unselected].slice(0, 4);
    }, [locations, selectedLocationIds]);

    const hasMore = locations.length > 4;

    return (
        <div className="w-full offer-locations-step mt-10 px-4">
            {/* Save and Exit in top right */}
            <div className="w-full max-w-[1100px] mx-auto relative">
                <div className="absolute top-[-75px] right-0">
                    <button
                        onClick={handleSaveExit}
                        className="px-6 h-[40px] border border-[#00ADEF] rounded-[5px] text-[#00ADEF] text-[14px] font-[500] font-poppins hover:bg-[#F0FBFF] transition-all"
                        disabled={saveLoading}
                        type="button"
                    >
                        {saveLoading ? "Saving..." : "Save and Exit"}
                    </button>
                </div>
            </div>

            <div className="sm:w-[100%] md:w-[90%] lg:w-[85%] xl:w-[65%] mx-auto">
                <div className="locations-header">
                    <h2>Choose Your <span>Store Locations</span></h2>
                    <p>Select the store locations where customers can redeem this offer.</p>
                </div>
                {locations.length === 0 ? (
                    <div className="empty-locations-container">
                        <div className="empty-locations-graphic">
                            <div className="placeholder-bar"><div className="shape pin" /><div className="line long" /></div>
                            <div className="placeholder-bar"><div className="shape pin" /><div className="line long" /></div>
                            <div className="placeholder-bar"><div className="shape pin" /><div className="line long" /></div>
                        </div>
                        <div className="empty-locations-text">
                            <h4>No Store Locations Added Yet</h4>
                            <p>You haven't added any Store locations yet. Add one to proceed.</p>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="all-stores-card">
                            <div className="card-inner">
                                <Checkbox
                                    text="Available Across All Stores"
                                    divClassName="flex items-center"
                                    checked={allStores}
                                    onChecked={handleAllStoresToggle}
                                    disabled={locations?.length === 0}
                                    textClass={`text-[15px] font-[600] font-poppins ml-2 text-[#303030]`}
                                    checkClassName="all-stores-checkbox"
                                />
                                <p>This applies to all stores added, ensuring your offer reaches every location.</p>
                            </div>
                        </div>

                        <div className="locations-selection-card" data-field="location">
                            <div className="card-header">
                                <label>Choose the Location for This Offer<span>*</span></label>
                                <span className="selected-count">{selectedLocationIds.length} Selected</span>
                            </div>
                            <div className="locations-list">
                                {displayedLocations.map((loc) => (
                                    <div
                                        key={loc._id}
                                        className={`store-location-item ${selectedLocationIds.includes(loc._id) ? 'selected' : ''}`}
                                        onClick={() => handleLocationToggle(loc._id, loc.name, loc)}
                                    >
                                        <div className={`checkbox-mini ${selectedLocationIds.includes(loc._id) ? 'checked' : ''}`}>
                                            {selectedLocationIds.includes(loc._id) && <TickIcon />}
                                        </div>
                                        <span className="address-text">{loc?.googlePlaceId?.address || loc?.address}</span>
                                    </div>
                                ))}
                            </div>
                            {hasMore && (
                                <span className="view-all-link" onClick={() => setViewAllVisible(true)}>
                                    View All
                                </span>
                            )}
                            {formik.errors.location && formik.touched.location && (
                                <span className="text-red-500 text-[12px] mt-2 block font-medium ms-1">
                                    {formik.errors.location}
                                </span>
                            )}
                        </div>
                    </>
                )}

                {/* Add Store Section */}
                <div className="add-store-section">
                    <label className="section-label">Add Store Location<span>*</span></label>
                    <div className="actions-grid">
                        <div className="action-card animate-on-load" onClick={() => setAddClicked(true)}>
                            <div className="icon-box">
                                <img src={LocationIcon} alt="location" />
                            </div>
                            <span className="action-title">Add A New Store Location</span>
                        </div>
                        <div className={`action-card csv-card animate-on-load ${csvDrawerOpen ? 'active' : ''}`} onClick={() => setCsvDrawerOpen(true)}>
                            <div className="icon-box">
                                <CSVIcon />
                            </div>
                            <span className="action-title">Upload Via CSV</span>
                        </div>
                    </div>
                </div>

            </div>

            {/* View All Modal */}
            <Modal
                open={viewAllVisible}
                onCancel={() => setViewAllVisible(false)}
                footer={null}
                width={window.innerWidth < 640 ? "95%" : 600}
                centered
                closeIcon={<CloseIconModal />}
                className="view-all-locations-modal"
            >
                <div className="modal-card-wrapper">
                    <div className="modal-custom-header">
                        <h2 className="modal-title">Current Locations</h2>
                        <span className="selected-count">{selectedLocationIds.length} Selected</span>
                    </div>
                    <div className="locations-scroll-area">
                        {locations.map((loc) => (
                            <div
                                key={loc._id}
                                className={`store-location-item ${selectedLocationIds.includes(loc._id) ? 'selected' : ''}`}
                                onClick={() => handleLocationToggle(loc._id, loc.name, loc)}
                            >
                                <div className={`checkbox-mini ${selectedLocationIds.includes(loc._id) ? 'checked' : ''}`}>
                                    {selectedLocationIds.includes(loc._id) && <TickIcon />}
                                </div>
                                <span className="address-text">{loc?.googlePlaceId?.address || loc?.address}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>

            {/* Add Location Drawer */}
            <Drawer
                placement="right"
                onClose={() => setAddClicked(false)}
                open={addClicked}
                width={window.innerWidth < 640 ? "100%" : 520}
                className="add-store-drawer add-location-sidebar"
                rootClassName="modern-drawer-root"
                closeIcon={null}
            >
                <div className="drawer-custom-header">
                    <div className="close-icon-wrapper" onClick={() => setAddClicked(false)}>
                        <CloseIconModal />
                    </div>
                    <div className="drawer-header-content">
                        <h2 className="drawer-title">Add New Store Location</h2>
                        <p className="drawer-subtitle">
                            Enter Store location info to help customers find you easily.
                        </p>
                    </div>
                </div>

                <AddNewLocation
                    allStores={allStores}
                    setLocations={setLocations}
                    setSelectedLocations={setSelectedLocations}
                    setSelectedLocationIds={setSelectedLocationIds}
                    setLocationNames={setLocationNames}
                    selectedMerchant={selectedMerchant}
                    onSuccess={() => setAddClicked(false)}
                    isDrawer={true}
                />
            </Drawer>

            <Drawer
                placement="right"
                onClose={() => setCsvDrawerOpen(false)}
                open={csvDrawerOpen}
                width={window.innerWidth < 640 ? "100%" : 520}
                className="add-store-drawer csv-upload-sidebar"
                rootClassName="modern-drawer-root"
                closeIcon={null}
            >
                <div className="drawer-custom-header">
                    <div className="close-icon-wrapper" onClick={() => setCsvDrawerOpen(false)}>
                        <CloseIconModal />
                    </div>
                    <div className="drawer-header-content">
                        <h2 className="drawer-title">Upload Locations via CSV</h2>
                        <p className="drawer-subtitle">
                            Quickly add multiple store locations by uploading a CSV file.
                        </p>
                    </div>
                </div>

                <UploadCSVDrawer
                    onClose={() => setCsvDrawerOpen(false)}
                    onUploadSuccess={(e) => {
                        handleAcceptedFiles(e);
                        // Don't close drawer immediately so user can see selection list
                    }}
                    isSubmitting={fileloading}
                    locations={locations}
                    selectedLocationIds={selectedLocationIds}
                    onSelectionChange={handleLocationToggle}
                    onBatchSelectionChange={handleBatchLocationSelection}
                />
            </Drawer>
        </div >
    );
};

export default Location;
